export const ServerSettings_UPDATE_REQUEST = "ServerSettings_UPDATE_REQUEST";
export const ServerSettings_UPDATE_SUCCESS = "ServerSettings_UPDATE_SUCCESS";
export const ServerSettings_UPDATE_FAILURE = "ServerSettings_UPDATE_FAILURE";
export const ServerSettings_UPDATE_RESET = "ServerSettings_UPDATE_RESET";